import Dropbox from 'dropbox';

const dropboxConfig = {
  clientId: 'ajg0ybz7kpdc13r',
  fetch,
};

const dbx = new Dropbox.Dropbox(dropboxConfig);

export default dbx;
